<template>
  <v-container fluid fill-height>
    <v-toolbar :color="expertColor" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Password Reset</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-flex xs12 sm12>
              <v-text-field
                v-validate="'required'"
                :error-messages="errors.collect('phone')"
                data-vv-name="phone"
                v-model="phone"
                label="Phone No. (Start with your country code +...)"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-text-field
                  v-validate="'required'"
                  :error-messages="errors.collect('password')"
                  data-vv-name="password"
                  v-model="password"
                  label="New Password"
                  type="password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <v-text-field
                  v-validate="'required'"
                  :error-messages="errors.collect('confirmPass')"
                  data-vv-name="confirmPass"
                  v-model="confirmPass"
                  label="Confirm Password"
                  type="password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="resetPass" :color="toolbarColor" dark>Reset</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <app-snackbar ref="mySnackbar"></app-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PasswordResetPage",
  components: {},
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["webUrl"])
  },
  data() {
    return {
      expertColor: "white",
      toolbarColor: null,
      userAccount: null,
      accountType: null,
      password: null,
      phone: null,
      confirmPass: null,
      err_msg: null,
      loading: false
    };
  },
  methods: {
    resetPass() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.password !== this.confirmPass) {
            this.$refs.mySnackbar.show("Passwords mismatch!", "red");
          } else {
            const data = {
              phone: this.phone,
              password: this.password
            };

            console.log(data, "ss");

            // submit data
            const self = this;
            const res = this.$store
              .dispatch("post", { url: "/user/password/request-change", data })
              .then(res => {
                if (res.state == false) {
                  this.$refs.mySnackbar.show(res.msg, "red");
                } else {
                  this.$router.push(
                    `/password/otp/${self.userAccount}/${self.phone}`
                  );
                }
              })
              .finally(() => {
                // stuffs happens here
              });
          }
        }
      });
    }
  },
  created() {
    const account = this.$route.params.status;
    this.userAccount = account;
    if (account == "expert") {
      this.accountType = "Fundi";
      this.toolbarColor = "blue darken-1";
    } else {
      this.accountType = "Sonko";
      this.toolbarColor = "green darken-1";
    }
  }
};
</script>



